import React from 'react';
import Icon from '../AppIcon';
import { useTheme } from '../../context/ThemeContext';

const Header = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="fixed top-0 left-0 right-0 z-[100] bg-card shadow-warm-md border-b border-border">
      <div className="h-16 px-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name="QrCode" size={24} color="var(--color-accent)" strokeWidth={2} />
          </div>
          <div>
            <h1 className="text-lg font-heading font-semibold text-foreground leading-none">
              QRCodeGen
            </h1>
            <p className="text-xs font-caption text-muted-foreground mt-0.5">
              Professional QR Code Generator
            </p>
          </div>
        </div>
        
        <button
          onClick={toggleTheme}
          className="w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors duration-250"
          aria-label="Toggle theme"
        >
          {theme === 'light' ? (
            <Icon name="Moon" size={20} color="var(--color-foreground)" strokeWidth={2} />
          ) : (
            <Icon name="Sun" size={20} color="var(--color-foreground)" strokeWidth={2} />
          )}
        </button>
      </div>
    </header>
  );
};

export default Header;